var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBackTop)?_c('div',{staticClass:"backTop",style:({ right: _vm.right + 'px', bottom: _vm.bottom + 'px' })},[_c('i',{staticClass:"iconfont icon-xsaaa",style:({ fontSize: _vm.fontSize + 'px'}),on:{"click":_vm.backTop}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }